import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

export const HeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const isPPUOriginUrl = (req: any) => {
    if (req.url.startsWith(environment.API_ROOT)) {
      return true;
    }
    return false;
  };

  if (isPPUOriginUrl(req)) {
    req = req.clone({
      setHeaders: {
        language: translate.currentLang,
        ClientType: 'customer_portal',
      },
    });
  }
  return next(req);
};
